import { isSVGElement } from '../utils/is-svg-element.mjs';
import { resolveElements } from '../utils/resolve-elements.mjs';
var resizeHandlers = new WeakMap();
var observer;

var getSize = function getSize(borderBoxAxis, svgAxis, htmlAxis) {
  return function (target, borderBoxSize) {
    if (borderBoxSize && borderBoxSize[0]) {
      return borderBoxSize[0][borderBoxAxis + "Size"];
    } else if (isSVGElement(target) && "getBBox" in target) {
      return target.getBBox()[svgAxis];
    } else {
      return target[htmlAxis];
    }
  };
};

var getWidth = /*@__PURE__*/getSize("inline", "width", "offsetWidth");
var getHeight = /*@__PURE__*/getSize("block", "height", "offsetHeight");

function notifyTarget(_ref) {
  var _resizeHandlers$get;

  var target = _ref.target,
      borderBoxSize = _ref.borderBoxSize;
  (_resizeHandlers$get = resizeHandlers.get(target)) === null || _resizeHandlers$get === void 0 ? void 0 : _resizeHandlers$get.forEach(function (handler) {
    handler(target, {
      get width() {
        return getWidth(target, borderBoxSize);
      },

      get height() {
        return getHeight(target, borderBoxSize);
      }

    });
  });
}

function notifyAll(entries) {
  entries.forEach(notifyTarget);
}

function createResizeObserver() {
  if (typeof ResizeObserver === "undefined") return;
  observer = new ResizeObserver(notifyAll);
}

function resizeElement(target, handler) {
  if (!observer) createResizeObserver();
  var elements = resolveElements(target);
  elements.forEach(function (element) {
    var _observer;

    var elementHandlers = resizeHandlers.get(element);

    if (!elementHandlers) {
      elementHandlers = new Set();
      resizeHandlers.set(element, elementHandlers);
    }

    elementHandlers.add(handler);
    (_observer = observer) === null || _observer === void 0 ? void 0 : _observer.observe(element);
  });
  return function () {
    elements.forEach(function (element) {
      var elementHandlers = resizeHandlers.get(element);
      elementHandlers === null || elementHandlers === void 0 ? void 0 : elementHandlers.delete(handler);

      if (!(elementHandlers !== null && elementHandlers !== void 0 && elementHandlers.size)) {
        var _observer2;

        (_observer2 = observer) === null || _observer2 === void 0 ? void 0 : _observer2.unobserve(element);
      }
    });
  };
}

export { resizeElement };